import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/shared/components/ui/button';
import {
  LabelInput,
  LabelInputProps,
} from '@/shared/components/ui/label-input';
import { cn } from '@/shared/utils/cn';

export type PasswordInputProps = LabelInputProps;

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    return (
      <LabelInput
        type={showPassword ? 'text' : 'password'}
        className={cn('pr-10', className)}
        ref={ref}
        {...props}
        suffixIcon={
          <Button
            type="button"
            className="h-full pr-3 hover:bg-transparent hover:text-foreground"
            btnType="icon"
            variant="ghost"
            onClick={togglePasswordVisibility}
            tabIndex={-1}
          >
            {showPassword ? <EyeOff /> : <Eye />}
          </Button>
        }
      />
    );
  },
);
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
